import { defineMessages } from 'react-intl';

export default defineMessages({
    AddressLine1: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Address Line 1',
        defaultMessage: 'Address Line 1',
    },
    AddressLine2: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Address Line 2',
        defaultMessage: 'Address Line 2',
    },
    AddressLine3: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Address Line 3',
        defaultMessage: 'Address Line 3',
    },
    City: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.City',
        defaultMessage: 'City',
    },
    PostalCode: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
    State: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.State',
        defaultMessage: 'State',
    },
    saveFailedMsg: {
        id: 'twia.commercial.premiumFinance.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.commercial.premiumFinance.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    nonStandardizedMessage: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
        defaultMessage: 'The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
    },
    standardizedMessage: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.The address you entered has been updated to follow USPS standards.',
        defaultMessage: 'The address you entered has been updated to follow USPS standards.',
    },
    standardizeAddressDetails: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.standardizeAddressDetails',
        defaultMessage: 'Standardize Address Details',
    },
    ZIPCodeValidationMessage: {
        id: 'twia.commercial.premiumFinance.Must be a valid postal code',
        defaultMessage: 'Must be a valid Zip Code/Postal Code.',
    },
    EmailValidationMessage: {
        id: 'twia.commercial.premiumFinance.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    Required: {
        id: 'twia.commercial.premiumFinance.This is a required field',
        defaultMessage: 'This is a required field.',
    },
    PhoneValidationMessage: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Phone',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    pleaseChoose: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Please Choose',
        defaultMessage: '-- Please Choose --',
    },
    cedexBureauMessage: {
        id: 'twia.commercial.premiumFinance.Value must be between 0 and 2 characters',
        defaultMessage: 'Value must be between 0 and 2 characters',
    },

});
